import { Route, Routes } from "react-router-dom";
import { Dashboard } from "../pages/Dashboard";

function CoreRoutes() {
  return (
    <Routes>
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
  );
}
export { CoreRoutes };

